"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDispatch = exports.useTrackedState = exports.Provider = exports.INITIAL_STATE = void 0;
const react_1 = require("react");
const react_tracked_1 = require("react-tracked");
const crypto_1 = require("../helpers/crypto");
const reducer_1 = require("./reducer");
const constants_1 = require("../data/constants");
const fiatCurrencies_1 = __importDefault(require("../data/fiatCurrencies"));
const cryptoOptions_1 = require("../data/cryptoOptions");
exports.INITIAL_STATE = {
    selectedCrypto: (0, crypto_1.allCryptoCurrencies)()[0],
    autoSelectProvider: true,
    locale: constants_1.DEFAULT_LOCALE,
    debug: false,
    debugOptions: {},
    fiatValue: 0,
    cryptoValue: 0,
    passThroughAddress: false,
};
const useValue = ({ locale, debug, initialCrypto, isBuy, disableAutoSelect = false, initialFiat, address, lockCrypto, hideTabs, providerPath, passThroughAddress, }) => {
    const [state, dispatch] = (0, react_1.useReducer)(reducer_1.reducer, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, exports.INITIAL_STATE), (0, cryptoOptions_1.getSelectedCrypto)(isBuy, initialCrypto)), (locale ? { locale } : {})), (debug ? { debug } : {})), (providerPath ? { providerPath } : {})), (initialFiat &&
        fiatCurrencies_1.default.some((i) => i.abbr.toUpperCase() === initialFiat.toUpperCase())
        ? { initialFiat, selectedFiat: initialFiat }
        : {})), (address ? { address } : {})), { autoSelectProvider: !disableAutoSelect, lockCrypto,
        hideTabs,
        passThroughAddress }));
    /*   useEffect(() => {
      console.log("state", state);
    }, [state]); */
    const dispatchWithLogging = (0, react_1.useCallback)((action) => {
        // console.log("action", action);
        dispatch(action);
    }, []);
    return [state, dispatchWithLogging];
};
_a = (0, react_tracked_1.createContainer)(useValue), exports.Provider = _a.Provider, exports.useTrackedState = _a.useTrackedState, exports.useDispatch = _a.useUpdate;
//# sourceMappingURL=store.js.map